var React = require('react');

function Open (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M74 77H26a3 3 0 01-3-3V26a3 3 0 013-3h18.5a3 3 0 110 6H29v42h42V55.5a3 3 0 116 0V74a3 3 0 01-3 3z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M77 26v14.28c0 1.66-1.34 3-3 3s-3-1.34-3-3v-7.04L52.12 52.12c-.58.59-1.35.88-2.12.88s-1.54-.29-2.12-.88a3 3 0 010-4.24L66.76 29h-7.04c-1.66 0-3-1.34-3-3s1.34-3 3-3H74c.15 0 .3.01.45.04.04 0 .08.01.12.02.09.01.17.03.26.06.2.05.39.13.57.23.08.04.17.09.25.15.09.05.17.11.239.18.16.12.311.27.431.43.069.07.13.15.18.24.06.08.11.17.15.25.1.18.18.37.229.57.03.09.05.17.061.26.01.04.02.08.02.12.03.15.04.3.04.45z","key":1})]);
}

Open.defaultProps = {"viewBox":"10 10 80 80"};

module.exports = Open;

Open.default = Open;
